import $ from 'jquery';

$(function () {
    const $app = $('#fhc-app');
    if (!$app.length) return;

    const totalSteps = 8;
    let currentStep = 1;
    let answers = {};

    const weights = {
        1: [0, 8, 16, 25], // Safety Cushion
        2: [0, 5, 12, 20], // Debt & Credit
        3: [0, 7, 15],     // FX & Inflation Shield
        4: [0, 3, 7, 12],  // Expense Tracking
        5: [0, 3, 7, 10],  // Savings Rate
        6: [0, 3, 6],      // Subscriptions
        7: [0, 3, 6],      // Household / Family
        8: [0, 3, 6]       // Active Yield (OVDP/Deposits)
    };

    const categories = {
        safety: { name: $app.data('cat-safety') || 'Safety Cushion', max: 35 },
        debt: { name: $app.data('cat-debt') || 'Debt & Credit', max: 20 },
        growth: { name: $app.data('cat-growth') || 'Capital & Inflation Shield', max: 21 },
        habits: { name: $app.data('cat-habits') || 'Expense Discipline', max: 24 }
    };

    const levelData = {
        stress: {
            title: $app.data('lvl-stress-title'),
            desc: $app.data('lvl-stress-desc'),
            badgeClass: 'bg-danger text-white',
            barClass: 'bg-danger'
        },
        basic: {
            title: $app.data('lvl-basic-title'),
            desc: $app.data('lvl-basic-desc'),
            badgeClass: 'bg-warning text-white',
            barClass: 'bg-warning'
        },
        solid: {
            title: $app.data('lvl-solid-title'),
            desc: $app.data('lvl-solid-desc'),
            badgeClass: 'bg-primary text-white',
            barClass: 'bg-primary'
        },
        fortress: {
            title: $app.data('lvl-fortress-title'),
            desc: $app.data('lvl-fortress-desc'),
            badgeClass: 'bg-success text-white',
            barClass: 'bg-success'
        }
    };

    const stepPrefix = $app.data('step-prefix') || 'Step';
    const stepOf = $app.data('step-of') || 'of';

    function updateStepUI() {
        $('.fhc-step-card').addClass('d-none');
        $(`#fhc-step-${currentStep}`).removeClass('d-none');

        const pct = Math.round((currentStep / totalSteps) * 100);
        $('#fhc-progress-bar').css('width', `${pct}%`).attr('aria-valuenow', pct);
        $('#fhc-step-counter').text(`${stepPrefix} ${currentStep} ${stepOf} ${totalSteps}`);

        // Update Prev button visibility
        if (currentStep === 1) {
            $('#fhc-btn-prev').addClass('invisible');
        } else {
            $('#fhc-btn-prev').removeClass('invisible');
        }

        // Check if current question already has an answer
        const currentAns = answers[currentStep];
        if (currentAns !== undefined) {
            $(`#fhc-step-${currentStep} .fhc-option-btn`).removeClass('active border-primary bg-light');
            $(`#fhc-step-${currentStep} .fhc-option-btn[data-idx="${currentAns}"]`).addClass('active border-primary bg-light');
            $('#fhc-btn-next').prop('disabled', false);
        } else {
            $('#fhc-btn-next').prop('disabled', true);
        }

        // Next or Finish button text
        if (currentStep === totalSteps) {
            $('#fhc-btn-next').addClass('d-none');
            $('#fhc-btn-finish').removeClass('d-none');
            if (currentAns === undefined) {
                $('#fhc-btn-finish').prop('disabled', true);
            } else {
                $('#fhc-btn-finish').prop('disabled', false);
            }
        } else {
            $('#fhc-btn-next').removeClass('d-none');
            $('#fhc-btn-finish').addClass('d-none');
        }

        // 4 Pillars Matrix & Methodology Hint synchronization
        const stepToPillar = {
            1: 'safety',
            2: 'debt',
            3: 'growth',
            4: 'habits',
            5: 'safety',
            6: 'habits',
            7: 'habits',
            8: 'growth'
        };
        const activePillar = stepToPillar[currentStep];

        const pillarSteps = {
            safety: [1, 5],
            debt: [2],
            growth: [3, 8],
            habits: [4, 6, 7]
        };

        Object.keys(pillarSteps).forEach(pKey => {
            const pSteps = pillarSteps[pKey];
            const allDone = pSteps.every(s => answers[s] !== undefined);
            const $item = $(`.fhc-pillar-item[data-pillar="${pKey}"]`);
            if (allDone) {
                $item.removeClass('active').addClass('completed');
                $item.find('.fhc-pillar-badge').removeClass('bg-light text-muted bg-primary text-white').addClass('bg-success text-white').html('<i class="bx bx-check"></i>');
            } else if (pKey === activePillar) {
                $item.removeClass('completed').addClass('active');
                $item.find('.fhc-pillar-badge').removeClass('bg-light text-muted bg-success text-white').addClass('bg-primary text-white').text(`${stepPrefix} ${currentStep}`);
            } else {
                $item.removeClass('active completed');
                $item.find('.fhc-pillar-badge').removeClass('bg-primary text-white bg-success text-white').addClass('bg-light text-muted').text($item.data('orig-badge') || '');
            }
        });

        // Dynamic Methodology Hint
        const hint = $app.data(`hint-s${currentStep}`);
        if (hint) {
            $('#fhc-methodology-hint').text(hint);
        }
    }

    // Option click
    $(document).on('click', '.fhc-option-btn', function () {
        const $btn = $(this);
        const qNum = parseInt($btn.closest('.fhc-step-card').data('step'), 10);
        const optIdx = parseInt($btn.data('idx'), 10);

        answers[qNum] = optIdx;

        $(`#fhc-step-${qNum} .fhc-option-btn`).removeClass('active border-primary bg-light');
        $btn.addClass('active border-primary bg-light');

        $('#fhc-btn-next').prop('disabled', false);
        $('#fhc-btn-finish').prop('disabled', false);

        // Smooth auto-advance after 220ms on mobile/desktop
        setTimeout(function () {
            if (currentStep < totalSteps) {
                currentStep++;
                updateStepUI();
            } else {
                calculateResults();
            }
        }, 220);
    });

    $('#fhc-btn-prev').on('click', function () {
        if (currentStep > 1) {
            currentStep--;
            updateStepUI();
        }
    });

    $('#fhc-btn-next').on('click', function () {
        if (currentStep < totalSteps && answers[currentStep] !== undefined) {
            currentStep++;
            updateStepUI();
        }
    });

    $('#fhc-btn-finish').on('click', function () {
        if (answers[currentStep] !== undefined) {
            calculateResults();
        }
    });

    function calculateResults() {
        let totalScore = 0;
        let catScores = {
            safety: 0,
            debt: 0,
            growth: 0,
            habits: 0
        };

        // Score summing
        for (let i = 1; i <= totalSteps; i++) {
            const chosen = answers[i] !== undefined ? answers[i] : 0;
            const pts = weights[i][chosen] || 0;
            totalScore += pts;

            if (i === 1 || i === 5) catScores.safety += pts;
            if (i === 2) catScores.debt += pts;
            if (i === 3 || i === 8) catScores.growth += pts;
            if (i === 4 || i === 6 || i === 7) catScores.habits += pts;
        }

        totalScore = Math.min(100, Math.max(0, totalScore));

        // Determine level
        let lvlKey = 'stress';
        if (totalScore >= 90) lvlKey = 'fortress';
        else if (totalScore >= 70) lvlKey = 'solid';
        else if (totalScore >= 40) lvlKey = 'basic';

        const lvl = levelData[lvlKey];

        // Animate counter
        $('#fhc-score-number').text(0);
        $('#fhc-score-card').removeClass('d-none');
        $('#fhc-quiz-card').addClass('d-none');

        // Scroll to results
        $('html, body').animate({
            scrollTop: $('#fhc-score-card').offset().top - 90
        }, 350);

        let currentCount = 0;
        const stepInc = Math.max(1, Math.floor(totalScore / 30));
        const timer = setInterval(function () {
            currentCount += stepInc;
            if (currentCount >= totalScore) {
                currentCount = totalScore;
                clearInterval(timer);
            }
            $('#fhc-score-number').text(currentCount);
        }, 25);

        $('#fhc-score-bar').css('width', `${totalScore}%`).attr('class', `progress-bar ${lvl.barClass}`);
        $('#fhc-level-badge').text(lvl.title).attr('class', `badge ${lvl.badgeClass} font-size-14 px-3 py-2 rounded-pill`);
        $('#fhc-level-desc').text(lvl.desc);

        // Mark all pillars as completed in the side panel
        $('.fhc-pillar-item').removeClass('active').addClass('completed');
        $('.fhc-pillar-badge').removeClass('bg-light text-muted bg-primary text-white').addClass('bg-success text-white').html('<i class="bx bx-check"></i>');
        $('#fhc-methodology-hint').html('✓ ' + ($app.data('lvl-solid-title') || 'Diagnostic Completed'));

        // Update category breakdown bars
        const safetyPct = Math.round((catScores.safety / categories.safety.max) * 100);
        const debtPct = Math.round((catScores.debt / categories.debt.max) * 100);
        const growthPct = Math.round((catScores.growth / categories.growth.max) * 100);
        const habitsPct = Math.round((catScores.habits / categories.habits.max) * 100);

        $('#fhc-cat-safety-val').text(`${safetyPct}%`);
        $('#fhc-cat-safety-bar').css('width', `${safetyPct}%`);

        $('#fhc-cat-debt-val').text(`${debtPct}%`);
        $('#fhc-cat-debt-bar').css('width', `${debtPct}%`);

        $('#fhc-cat-growth-val').text(`${growthPct}%`);
        $('#fhc-cat-growth-bar').css('width', `${growthPct}%`);

        $('#fhc-cat-habits-val').text(`${habitsPct}%`);
        $('#fhc-cat-habits-bar').css('width', `${habitsPct}%`);

        // Dynamic Growth Priorities
        const $prioritiesList = $('#fhc-priorities-list');
        $prioritiesList.empty();

        const recSafetyTitle = $app.data('rec-safety-title') || 'Emergency cushion:';
        const recSafetyText = $app.data('rec-safety-text') || '';
        const recDebtTitle = $app.data('rec-debt-title') || 'Debt burden:';
        const recDebtText = $app.data('rec-debt-text') || '';
        const recHabitsTitle = $app.data('rec-habits-title') || 'Expense discipline:';
        const recHabitsText = $app.data('rec-habits-text') || '';
        const recGrowthTitle = $app.data('rec-growth-title') || 'Inflation shield:';
        const recGrowthText = $app.data('rec-growth-text') || '';
        const recMasteryTitle = $app.data('rec-mastery-title') || 'Capital growth:';
        const recMasteryText = $app.data('rec-mastery-text') || '';

        if (catScores.safety < 20) {
            $prioritiesList.append(`
                <li class="mb-2 d-flex align-items-start">
                    <i class="bx bx-error-circle text-danger font-size-18 me-2 mt-1 flex-shrink-0"></i>
                    <span><strong>${recSafetyTitle}</strong> ${recSafetyText}</span>
                </li>
            `);
        }
        if (catScores.debt < 15) {
            $prioritiesList.append(`
                <li class="mb-2 d-flex align-items-start">
                    <i class="bx bx-credit-card text-warning font-size-18 me-2 mt-1 flex-shrink-0"></i>
                    <span><strong>${recDebtTitle}</strong> ${recDebtText}</span>
                </li>
            `);
        }
        if (catScores.habits < 16) {
            $prioritiesList.append(`
                <li class="mb-2 d-flex align-items-start">
                    <i class="bx bx-receipt text-primary font-size-18 me-2 mt-1 flex-shrink-0"></i>
                    <span><strong>${recHabitsTitle}</strong> ${recHabitsText}</span>
                </li>
            `);
        }
        if (catScores.growth < 15) {
            $prioritiesList.append(`
                <li class="mb-2 d-flex align-items-start">
                    <i class="bx bx-line-chart text-success font-size-18 me-2 mt-1 flex-shrink-0"></i>
                    <span><strong>${recGrowthTitle}</strong> ${recGrowthText}</span>
                </li>
            `);
        }
        if ($prioritiesList.children().length === 0) {
            $prioritiesList.append(`
                <li class="mb-2 d-flex align-items-start">
                    <i class="bx bx-check-double text-success font-size-18 me-2 mt-1 flex-shrink-0"></i>
                    <span><strong>${recMasteryTitle}</strong> ${recMasteryText}</span>
                </li>
            `);
        }
    }

    $('#fhc-btn-restart').on('click', function () {
        answers = {};
        currentStep = 1;
        $('#fhc-score-card').addClass('d-none');
        $('#fhc-quiz-card').removeClass('d-none');
        updateStepUI();
        $('html, body').animate({
            scrollTop: $('#fhc-quiz-card').offset().top - 90
        }, 300);
    });

    updateStepUI();
});
